import { render, staticRenderFns } from "./QuotationStepRisk2.vue?vue&type=template&id=39227ef4"
import script from "./QuotationStepRisk2.vue?vue&type=script&lang=js"
export * from "./QuotationStepRisk2.vue?vue&type=script&lang=js"
import style0 from "./QuotationStepRisk2.vue?vue&type=style&index=0&id=39227ef4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports